import {FileButton} from '@mantine/core';

FileButton.displayName = 'FileButton';

export {FileButton, type FileButtonProps} from '@mantine/core';
